import './schedTable.scss';
import { useState } from 'react';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import api from '../../services/api';

const retrieveSchedules = async (page) => {
  const res = await api.get('/api/osint/schedule/', { params: { page } });
  return res.data;
}

const SchedTable = (props) => {
    // We will show a table with all the schedules, we will use a option to filter only by active
    const [currentPage, setCurrentPage] = useState(1);
    const {
      data: schedules,
      error,
      isLoading,
      isFetching,
    } = useQuery(
      ["schedules", currentPage],
      () => retrieveSchedules(currentPage),
      { keepPreviousData: true }
    );
    if (isLoading) return <div>Fetching schedules...</div>;
    if (error) return <div>An error occurred: {error.message}</div>;

    // The scheds have the following attributes:
    // name, task_name, frequency, start, end, enabled, last_run, metadata
    // inside metadata we have the target and the case
    return (
        <div className="schedTable">
        <h1>Schedules</h1>
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Task</th>
                        <th>Frequency</th>
                        <th>Start</th>
                        <th>End</th>
                        <th>Last Run</th>
                        <th>Enabled</th>
                    </tr>
                </thead>
                <tbody>
                    {schedules.results.map((sched) => (
                        <tr key={sched.id}>
                            <td>{sched.name}</td>
                            <td>{sched.task_name}</td>
                            <td>{sched.frequency} {sched.frequency > 1? 'mins': 'min'}</td>
                            <td>{format(new Date(sched.start_time), 'yyyy-MM-dd HH:mm:ss')}</td>
                            <td>{sched.end_time? format(new Date(sched.end_time), 'yyyy-MM-dd HH:mm:ss'): ''}</td>
                            <td>{sched.last_run ? format(new Date(sched.last_run), 'yyyy-MM-dd HH:mm:ss') : ''}</td>
                            <td>{sched.enabled ? 'Yes' : 'No'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {/* Pagination Controls */}
      <div className="pagination">
      <button
          onClick={() => setCurrentPage(1)}
          disabled={!schedules.previous}
        >
          &lt;&lt;
        </button>
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={!schedules.previous}
        >
          &lt;
        </button>
        <button
          // Scroll to top of the page
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >Top
        </button>
        <span>Records: ({schedules.count})&nbsp;-&nbsp;</span>
        <span>Page {currentPage} of {Math.ceil(schedules.count / 10)}</span>

        <button
          onClick={() => {
            if (schedules.next) {
              setCurrentPage((prev) => prev + 1);
            }
          }}
          disabled={!schedules.next}
        >
          &gt;
        </button>
        <button
          onClick={() => {
            if (schedules.next) {
              setCurrentPage(Math.ceil(schedules.count / 10));
            }
          }}
          disabled={!schedules.next}
        >
          &gt;&gt;
        </button>
      </div>
        </div>
    ); 
};

export default SchedTable;